import React, { useState, lazy, useEffect } from "react";
import { connect } from 'react-redux';
import ConversationOld from './conversation';
import ConversationThird from './conversation-third';
import apiGuidance from "@/apis/pc/guidance/guidance";
import _ from 'lodash';

const mapDispatchToProps = { };

const mapStateToProps = (state) => {
  const { messageSettingsOpen: {thirdChatAuth, comAuthInfo, messageOpenParams, companyNoExpire}, enterPriseInfo } = state
  return { thirdChatAuth, comAuthInfo, messageOpenParams, companyNoExpire, ...enterPriseInfo }
}

/**
 * @设计理念: 整个消息存档维护3个参数，无论是在联系人列表，搜索结果列表，右侧搜索都是统一的逻辑
 * @params: operateData（当前查看的员工, 联系人列表使用）
 * @params: currentSession（当前操作的会话）
 * @params: currentMessage（当前操作的消息）
 */
const Conversation = (props) => {
  const { enterPriseInfo, messageOpenParams, companyNoExpire, thirdChatAuth } = props
  const [showTrial, setShowTrial] = useState(false);
  const [showThrid, setShowThrid] = useState(false);
  const [showHistoryGray, setShowHistoryGray] = useState(false); // 展示旧版入口

  useEffect(() => {
    if (props.companyNoExpire?.lastChatVersion == 2) {
      // 三方
      setShowTrial(true);
    } else if (props.companyNoExpire?.lastChatVersion == 1) {
      setShowTrial(false);
    }else if ( props.companyNoExpire?.onLyThird || (props.companyNoExpire?.isThrid && props.thirdChatAuth?.auth && !props.companyNoExpire.isBind)) {
      // 三方
      setShowTrial(true);
    }
  }, [props.thirdChatAuth, props.companyNoExpire])

  useEffect(() => {
    const urlParams = getUrlParams(decodeURI(window.location.href));
    const targetType = urlParams.targetType;
    const targetId = urlParams.targetId;
    if (isWeWorkEnvironment()) {
      wx.openEnterpriseChat({
        userIds: '',
        externalUserIds: targetType === "customer" ? targetId : '',
        groupName: '',
        chatId: targetType === "group" ? targetId : '',
        success: () => {
          console.log('成功')
        },
        fail: (err) => {
          console.log('openEnterpriseChat', err?.errMsg)
        },
      });
    }
    apiGuidance.getMessageOpenParams().then(res => {
      if (res.code === 0) {
        setShowHistoryGray(_.get(res, 'data.historyGray', false));
      }
    })
  }, [])

  const isWeWorkEnvironment = () => {
    var ua = window.navigator.userAgent.toLowerCase();
    return /wxwork/.test(ua) || /micromessenger/.test(ua);
  }

  const getUrlParams = (url) => {
    const reg = /(\w+)=([^&]+)/g;
    const params = {};
    let match;
    
    while ((match = reg.exec(url)) !== null) {
      params[match[1]] = match[2];
    }
    
    return params;
  }



  return (
    (!showTrial || showThrid) ? <ConversationOld {...props} showHistoryGray={showHistoryGray} onChange={() => {setShowThrid(!showThrid)}}/> : <ConversationThird {...props} showHistoryGray={showHistoryGray} onChange={() => {setShowThrid(!showThrid)}}/>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Conversation);
